angular.module('impactx.cube').directive('ixCubeCompile', ['$compile', function ($compile)
{
    return function (scope, element, attrs)
    {
        scope.$watch(
            function (scope)
            {
                return scope.$eval(attrs.compileRefresh).value;
            },
            function (value)
            {
                if (value)
                {
                    element.html(scope.$eval(attrs.ixCubeCompile));
                    $compile(element.contents())(scope);
                    scope.$eval(attrs.compileRefresh).value = false;
                }

            }
        )
    }
}]);